import InputTypesEnum from '../../Enums/InputTypesEnum';
import ValidityHelper from '../../Helpers/ValidityHelper';
import NotificationService from '../../Services/NotificationService';
import MassMessageItem from '../../Domain/MassMessageItem';

export default class MassMessagePanelDescription {
  static titleForCreate = 'Mass Message';
  static titleForEdit = 'Mass Message';
  static itemType = MassMessageItem;
  static messageOnSuccess = 'Message sent.';
  static serviceFunction = (edited) => NotificationService.SendMassMessage(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Message',
      fields: [
        {
          fieldName: 'RecipientSummary',
          label: 'Recipients',
          className: 'col-12',
          type: InputTypesEnum.TextBoxReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'Subject',
          label: 'Subject *',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'Message',
          label: 'Message *',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];
}
